import axios from 'axios';
import config from '../../config/app';

const createIncident = service => axios({
  method: 'POST',
  baseURL: config.BASE_PATH,
  url: '/api/v1/incidents',
  headers: { 'X-PagerDuty-Api-Local': 1 },
  data: {
    incident: {
      type: 'incident',
      title: 'Example Incident',
      service: {
        id: service.id,
        type: 'service_reference'
      },
      escalation_policy: {
        id: service.escalation_policy.id,
        type: 'escalation_policy_reference'
      }
    }
  }
});

export default createIncident;
